import { SkipLink } from 'nhsuk-react-components';
import PageFooter from '../components/Footer/Footer.tsx';
import HomeHeader from '../components/HomeHeader/HomeHeader.tsx';
import MainContent from '../components/LandingPage/MainContent.tsx';

function LandingPage() {
  return (
    <>
      <SkipLink />
      <HomeHeader />
      <MainContent />
      <PageFooter />
    </>
  );
}

export default LandingPage;
